<template>
  <div>
    <ClientInvoices v-if="$getConstRole('ROLE_CLIENT') == role"></ClientInvoices>
    <AgentInvoices v-if="$getConstRole('ROLE_AGENT') == role"></AgentInvoices>
    <AccountantInvoices v-if="$getConstRole('ROLE_ACCOUNTING') == role"></AccountantInvoices>
    <AdminInvoices v-if="$getConstRole('ROLE_ADMIN') == role"></AdminInvoices>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ClientInvoices from '@/views/client/invoice/List.vue'
import AgentInvoices from '@/views/agent/invoice/List.vue'
import AccountantInvoices from '@/views/accountant/Invoices.vue'
import AdminInvoices from '@/views/admin/invoices/Invoices.vue'

export default {
  name: 'Invoices',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    AccountantInvoices,
    ClientInvoices,
    AdminInvoices,
    AgentInvoices
  },
};
</script>
